import React from "react";

export default function Card({
	children,
	title,
	classes,
	...rest
}: {
	title: string;
	children?: React.ReactNode;
	classes?: string;
	[key: string]: any;
}) {
	return (
		<div
			className={`card shadow ${classes}`}
			style={{
				border: "1px solid #e3e6f0",
				borderRadius: ".35rem",
				margin: "auto"
			}}
			{...rest}
		>
			<div className="card-header py-3">
				<h6 className="m-0 font-weight-bold text-primary">{title}</h6>
			</div>

			<div className="card-body">{children}</div>
		</div>
	);
}
